import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkout" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexCheckout',
  setup(__props) {

const Card9 = defineAsyncComponent(() => import("@/components/commen/card/cardData9.vue"))
const checkoutForm = defineAsyncComponent(() => import("@/components/theme/ecommerce/checkout/checkoutForm.vue"))
const checkoutDetail = defineAsyncComponent(() => import("@/components/theme/ecommerce/checkout/checkoutDetail.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumbs, {
      main: "Ecommerce",
      title: "Checkout"
    }),
    _createVNode(_unref(Card9), {
      colClass: "container-fluid",
      cardhaderClass: "title-header",
      title: "Billing Details"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(checkoutForm)),
          _createVNode(_unref(checkoutDetail))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})